export const compareValues = (a: any, b: any): number => {
	if (a == null || b == null) {
		return (a == null ? 0 : 1) - (b == null ? 0 : 1);
	}
	if (typeof a === 'string' && typeof b === 'string') {
		return a.localeCompare(b, undefined, { numeric: true });
	}
	return a < b ? -1 : (a > b ? 1 : 0);
};
